import React,{
    useState, 
    useRef, 
    useEffect, 
    forwardRef,
    useImperativeHandle
} from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faPlus, faXmark, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import { toast } from 'react-toastify';
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";

import "../../../../../../../../../../cssModule/tagifyModyfi.css";

// ---------- component import ---------- //
import { specialCharacterValidate } from '../../../../../../../../../component/common/Helper';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';

const ProductForm = forwardRef((props, ref) => {
    const {
        productSave, 
        updateProductList,
        formValidateError,
        formActionType,
    } = props;

    const productFromRef = useRef();
    // ----- tagify set ------- //
    const productSynonymsRef = useRef(null);
    const tagifyRef = useRef(null);
    useEffect(() => {
        if (productSynonymsRef.current) {
            tagifyRef.current = new Tagify(productSynonymsRef.current);
        }
        return () => {
            if (tagifyRef.current) {
                tagifyRef.current.destroy();
            }
        };
    },[]);

    // -------------- product input data manage ----------- //

    const [ productError, setProductError ] = useState({});
    const [ productFormData, setProductFormData ] = useState({ 
        product_name : "",
        product_synonyms : "",
    });

    const validateField = (name, value) => {
        let error = "";
        if (name === "product_name") {
            if (!value) {
                error = "Product name is required.";
            } 
        }
        return error;
    };

    const productOnInputChange = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);
            setProductError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setProductFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
        else if (selectedOption?.target) {
            const { name, type, value, checked } = selectedOption.target;
            let newVal = value
            if(name === 'product_name'){
                newVal = specialCharacterValidate(value)
            }
            const fieldError = validateField(name, value);
            setProductError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setProductFormData((prevData) => ({
                ...prevData,
                [name]: newVal,
            }));
        }
    };

    const productSaveHandler = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in productFormData) {
            newErrors[key] = validateField(key, productFormData[key]);
        }
        setProductError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            let dataObject = {
                product_name: productFormData.product_name,
                product_synonyms: productFormData.product_synonyms,
            };
            productSave(dataObject)
        }
    }

    useEffect(() => {
        if( updateProductList.length > 0 ){
            let productUpdateData = updateProductList[0];
            if(formActionType === 'update'){
                setProductFormData((prevState) => ({
                    ...prevState,
                    product_name: productUpdateData.product_name,
                }));
                setTimeout(() => {
                    if (productSynonymsRef.current) {
                        tagifyRef.current.removeAllTags();
                        tagifyRef.current.addTags(productUpdateData.product_synonyms);
                    }
                }, 100);
                setProductError({})
            }
            else{
                setProductFormData((prevState) => ({
                    ...prevState,
                    product_name: "",
                    product_synonyms: "",
                }));
            }
        }
    },[updateProductList])

    const infoPopupData = {
        'product_name' : {
            'title' : 'Product name',
            'info' : 'The Product name should be unique. For example, it can be XX EV, or Guest Rooms. Create all Products/Service names you have.',
        },
        'product_synonyms' : {
            'title' : 'Synonyms',
            'info' : 'Enlist all synonyms that go with your Product or Service name.'
        }
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
        
    }
    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setProductFormData({
                product_name: '',
                product_synonyms: '',
            });
        }
    }));


    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <form ref={productFromRef} className='mb-5'>
                        <div className='row'>
                            <div className='col-md-12 mb-5'>
                                <label className="form-label required">
                                    Product Name
                                </label>
                                {
                                    formActionType === 'insert' && 
                                    <>
                                        <span 
                                            className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                            onClick={(e) => infoOpenOnCLick('product_name')}
                                        >
                                            <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                        </span>
                                    </>
                                }
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Enter product name"
                                    name='product_name'
                                    onChange={productOnInputChange}
                                    value={productFormData.product_name}
                                    autoFocus
                                />
                                {productError.product_name && (
                                    <ValidationMessage className='text-danger' message ={productError.product_name}/>
                                )}
                            </div>
                            <div className='col-md-12'>
                                <label className="form-label">
                                    Synonyms
                                </label>
                                {
                                    formActionType === 'insert' &&
                                    <>
                                        <span 
                                            className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                                            onClick={(e) => infoOpenOnCLick('product_synonyms')}
                                        >
                                            <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                        </span>
                                    </>
                                }
                                <span 
                                    className="fs-6 fw-semibold text-primary ms-2 float-end">
                                    (Press Enter to add each synonym)
                                </span>
                                <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    placeholder="Enter product synonyms"
                                    name='product_synonyms'
                                    ref={productSynonymsRef}
                                    onChange={productOnInputChange}
                                    value={productFormData.product_synonyms}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div className='col-md-12 m-auto text-end'>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className="btn btn-dark btn-icon btn-sm me-2"
                            onClick={productSaveHandler}
                        >
                            <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className="btn btn-primary btn-sm me-2"
                            onClick={productSaveHandler}
                        >
                            Update
                        </div>
                    }
                </div>
                <div className='col-md-12 mt-5'>
                    {
                        formValidateError?.product_setup &&
                        <AlertMessage
                            sub_title = {formValidateError?.product_setup}
                            type = 'danger'
                        />
                    }
                </div>
            </div>
        </>
    )
})

export default ProductForm